import { ModuleEnum } from '~/constants/systemEnum'
import { clearOrganization, currentOrganization } from '~/core/services/OrganizationService'

const publicPaths = ['/account/login', '/account/forgot-password']

const routeModules: { prefix: string; module: ModuleEnum }[] = [
  { prefix: '/news', module: ModuleEnum.News },
  { prefix: '/gallery', module: ModuleEnum.Gallery },
  { prefix: '/contact', module: ModuleEnum.Contact },
  { prefix: '/static-page', module: ModuleEnum.StaticPage },
  { prefix: '/language', module: ModuleEnum.Translation },
  { prefix: '/translation', module: ModuleEnum.Translation },
  { prefix: '/product', module: ModuleEnum.Product },
  { prefix: '/class', module: ModuleEnum.Class },
  { prefix: '/order', module: ModuleEnum.Order },
  { prefix: '/consultation-registration', module: ModuleEnum.ConsultationRegistration },
  { prefix: '/category', module: ModuleEnum.Category },
  { prefix: '/locality', module: ModuleEnum.Category },
  { prefix: '/account', module: ModuleEnum.User },
  { prefix: '/system-config', module: ModuleEnum.User },
  { prefix: '/user-identifier', module: ModuleEnum.User },
  { prefix: '/role', module: ModuleEnum.Role },
  { prefix: '/module', module: ModuleEnum.Role },
  { prefix: '/school', module: ModuleEnum.School },
  { prefix: '/academic-year', module: ModuleEnum.AcademicYear },
]

export default defineNuxtRouteMiddleware(async (to) => {
  if (!process.client) return

  // Ngữ cảnh trường / tổ chức chỉ dùng trong khu quản lý trường / tổ chức. Rời khu này → về hệ thống
  // (X-ObjectId = 0, API hiểu là đơn vị hệ thống) để không thao tác nhầm dữ liệu / quyền của trường.
  if (!to.path.startsWith('/school') && !to.path.startsWith('/organization') && currentOrganization() !== 0) {
    clearOrganization()
  }
  if (publicPaths.some((path) => to.path.startsWith(path))) return

  const matched = routeModules.find((item) => to.path.startsWith(item.prefix))
  if (!matched) return

  const systemStore = useSystemStore()
  if (!systemStore.isInited) {
    await systemStore.init()
  }

  const { canAccess } = usePermission()
  if (!canAccess(matched.module)) {
    return navigateTo('/')
  }
})
